export interface SocialNetworkProps {
  id: string;
  name: string;
  type: string;
  url: string;
  icon: string;
  isActive: boolean;
  displayOrder: number;
  createdAt: Date;
  updatedAt: Date;
}

export class SocialNetwork {
  private readonly _id: string;
  private _name: string;
  private _type: string;
  private _url: string;
  private _icon: string;
  private _isActive: boolean;
  private _displayOrder: number;
  private readonly _createdAt: Date;
  private _updatedAt: Date;

  private constructor(props: SocialNetworkProps) {
    this._id = props.id;
    this._name = props.name;
    this._type = props.type;
    this._url = props.url;
    this._icon = props.icon;
    this._isActive = props.isActive;
    this._displayOrder = props.displayOrder;
    this._createdAt = props.createdAt;
    this._updatedAt = props.updatedAt;
  }

  public static create(props: {
    id: string;
    name: string;
    type: string;
    url: string;
    icon?: string;
    isActive?: boolean;
    displayOrder?: number;
    createdAt?: Date | string;
    updatedAt?: Date | string;
  }): SocialNetwork {
    return new SocialNetwork({
      id: props.id,
      name: props.name,
      type: props.type,
      url: props.url,
      icon: props.icon || props.type.toLowerCase(),
      isActive: props.isActive ?? true,
      displayOrder: props.displayOrder ?? 0,
      createdAt: props.createdAt ? new Date(props.createdAt) : new Date(),
      updatedAt: props.updatedAt ? new Date(props.updatedAt) : new Date(),
    });
  }

  public get id(): string {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public get type(): string {
    return this._type;
  }

  public get url(): string {
    return this._url;
  }

  public get icon(): string {
    return this._icon;
  }

  public get isActive(): boolean {
    return this._isActive;
  }

  public get displayOrder(): number {
    return this._displayOrder;
  }

  public get createdAt(): Date {
    return this._createdAt;
  }

  public get updatedAt(): Date {
    return this._updatedAt;
  }
}
